import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/more',
    name: 'more',
    component: () => import('../views/More.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/add_post',
    name: 'add_post',
    component: () => import('../views/posts/PostForm.vue'),
    meta: { allowAnonymous: false },
  },
  {
    path: '/post/:post_id/edit',
    name: 'edit_post',
    component: () => import('../views/posts/PostForm.vue'),
    meta: { allowAnonymous: false },
  },
  {
    path: '/add_search',
    name: 'add_search',
    component: () => import('../views/posts/AdvanceSearchForm.vue'),
    meta: { allowAnonymous: false },
  },
  {
    path: '/searches/:id',
    name: 'search',
    props: true,
    component: () => import('../views/posts/AdvanceSearch.vue'),
    meta: { allowAnonymous: false },
  },
  {
    path: '/post/:id',
    name: 'post_detail',
    props: true,
    component: () => import('../views/posts/Detail.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/post/:id/message/:user?',
    name: 'message_listing',
    props: true,
    component: () => import('../views/users/MessageListing.vue'),
  },
  {
    path: '/looking',
    name: 'looking',
    component: () => import('../views/posts/Looking.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/tagged/:name',
    name: 'tagged',
    props: true,
    component: () => import('../views/posts/Tagged.vue'),
    meta: { allowAnonymous: false },
  },
  {
    path: '/users/search/:search',
    name: 'users_search',
    props: true,
    component: () => import('../views/users/UsersSearch.vue'),
    meta: { allowAnonymous: false },
  },
  {
    path: '/groups',
    name: 'all_groups',
    props: true,
    component: () => import('../views/groups/Groups.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/groups/:id',
    name: 'group_detail',
    props: true,
    component: () => import('../views/groups/GroupDetail.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/groups/:id/chat',
    name: 'chat_group',
    props: true,
    component: () => import('../views/groups/GroupChat.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/groups/:id/edit',
    name: 'edit_group',
    props: true,
    component: () => import('../views/groups/GroupForm.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/groups/:id/members',
    name: 'group_members',
    props: true,
    component: () => import('../views/groups/GroupMembers.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/add_group',
    name: 'add_group',
    props: true,
    component: () => import('../views/groups/GroupForm.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('../views/users/Registration.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/verify-email/:token',
    name: 'verify_email',
    props: true,
    component: () => import('../views/users/VerifyEmail.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/resend-verification-email',
    name: 'resend_verification_email',
    component: () => import('../views/users/ResendVerificationEmail.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/users/Login.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/users/Logout.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot_password',
    component: () => import('../views/users/ForgotPassword.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/reset-password/:token',
    name: 'reset_password',
    props: true,
    component: () => import('../views/users/ResetPassword.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/start-password/:token',
    name: 'start_password',
    props: true,
    component: () => import('../views/users/StartPassword.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '/profile/:id',
    name: 'profile',
    props: true,
    component: () => import('../views/users/Profile.vue'),
  },
  {
    path: '/profile/:id/message',
    name: 'message_profile',
    props: true,
    component: () => import('../views/users/MessageProfile.vue'),
  },
  {
    path: '/update-profile',
    name: 'update_profile',
    component: () => import('../views/users/UpdateProfile.vue'),
  },
  {
    path: '/listings',
    component: () => import('../views/listings/Main.vue'),
    children: [
      {
        path: '',
        name: 'all_listings',
        component: () => import('../views/listings/All.vue'),
        meta: { allowAnonymous: true },
      },
      {
        path: '/favorites',
        name: 'favorites',
        component: () => import('../views/posts/Favorites.vue'),
        meta: { allowAnonymous: false },
      },
      {
        path: 'sold',
        name: 'sold_listings',
        component: () => import('../views/listings/Sold.vue'),
        meta: { allowAnonymous: true },
      },
      {
        path: 'auctions',
        name: 'auctions',
        component: () => import('../views/listings/Auctions.vue'),
        meta: { allowAnonymous: true },
      },
      {
        path: 'mine',
        name: 'user_listings',
        component: () => import('../views/listings/User.vue'),
      },
      {
        path: ':categorySlug',
        name: 'listing_category',
        component: () => import('../views/listings/Category.vue'),
        meta: { allowAnonymous: true },
        props: true,
      },
    ],
  },
  {
    path: '/messages',
    component: () => import('../views/conversations/Main.vue'),
    children: [
      {
        path: '',
        name: 'conversations_conversations',
        component: () => import('../views/conversations/Conversations.vue'),
      },
      {
        path: 'archived',
        name: 'conversations_archived',
        component: () => import('../views/conversations/Archived.vue'),
      },
      {
        path: 'deleted',
        name: 'conversations_deleted',
        component: () => import('../views/conversations/Deleted.vue'),
      },
      {
        path: ':conversationId',
        name: 'conversations_conversation',
        component: () => import('../views/conversations/Conversation.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/c/:room/:lastId',
    name: 'chat-redirect',
    component: () => import('../views/conversations/ChatRedirect.vue'),
    props(route) {
      return {
        room: route.params.room,
        lastId: parseInt(route.params.lastId, 10),
      };
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('../views/users/Notifications.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminDashboard.vue'),
  },
  {
    path: '/page/:slug',
    name: 'flatpage',
    props: true,
    component: () => import('../views/Flatpage.vue'),
    meta: { allowAnonymous: true },
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/PageNotFoundView.vue'),
    meta: { allowAnonymous: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  store.commit('latestFromRoute', from);

  if (to.matched.some(record => record.meta.allowAnonymous)) {
    next();
  } else if (store.state.userData === null) {
    next({
      name: 'login',
      query: { next: to.fullPath },
    });
  } else {
    next();
  }
});

export default router;
